import Component from '@glimmer/component';

import { concat, array } from '@ember/helper';
import { linkToAction } from 'ember-route-state/decorators/link-to-action.js';

import AddButton from 'rise-ui/components/add-button.gjs';
import CButton from 'rise-ui/components/c-button.gjs';
import ExpandingBlock from 'rise-ui/components/expanding-block.gjs';
import and from 'rise-ui/helpers/and.js';
import arrayConcat from 'rise-ui/helpers/array-concat.js';
import classMod from 'rise-ui/helpers/class-mod.js';
import concatClasses from 'rise-ui/helpers/concat-classes.js';
import groupedItemsWithResult from 'rise-ui/helpers/grouped-items-with-result.js';
import itemTypeId from 'rise-ui/helpers/item-type-id.js';
import itemTypeIdsEq from 'rise-ui/helpers/item-type-ids-eq.js';
import not from 'rise-ui/helpers/not.js';
import oneString from 'rise-ui/helpers/one-string.js';
import or from 'rise-ui/helpers/or.js';
import parameterTimestep from 'rise-ui/helpers/parameter-timestep.js';
import parameterTransformation from 'rise-ui/helpers/parameter-transformation.js';
import parameterUnit from 'rise-ui/helpers/parameter-unit.js';
import recordsWithResult from 'rise-ui/helpers/records-with-result.js';
import string from 'rise-ui/helpers/string.js';
import timeSeriesSelect from 'rise-ui/helpers/time-series-select.js';
import titleCase from 'rise-ui/helpers/title-case.js';

@linkToAction
export default class TimeSeriesSearchResultComponent extends Component {
  <template>
    <div
      class={{concatClasses
        "c-time-series-search-result qa-search-result"
        (classMod "c-search-result" @type (concat "--" @type))
      }}
      ...attributes
    >
      <ExpandingBlock @button={{true}}
        @iconClass="c-time-series-search-result__expander"
        @disabled={{not @location.validCatalogRecords.length}}
        @disabledAddText="Location has no Catalog Records"
      >
        <:head>
          <h3 class="c-item-title c-time-series-search-result__name qa-search-result-head">
            {{@location.name}}
            {{#if (or @allowRemove @location.validCatalogRecords.length)}}
              {{#let
                (if @added "Location was Added; Click to Remove" "Add Location to Selection")
                (and (not @added) @warningAdd)
                (and (not @added) @disableAdd)
                as | locationMessage warningAdd disabled |
              ~}}
              <AddButton @context={{or @context "add"}}
                @classMix="c-time-series-search-result__add-button qa-search-result-add"
                @classMod={{arrayConcat (array warningAdd "--warning") (or @classMod (array))}}
                @title={{or warningAdd locationMessage}}
                @added={{@added}}
                @linkTo={{timeSeriesSelect toggleLocation=@location.id}}
                @disabled={{disabled}}
              />
              {{~/let}}
            {{/if}}
          </h3>
          {{#unless @location.validCatalogRecords.length}}
            <p class="c-catalog-search-result__no-items-hint">
              {{string "location-no-records-hint"}}
            </p>
          {{/unless}}
          {{yield}}
        </:head>
        <:body>
          <CButton @type="small muted" @external="true"
            @linkTo={{array "location-detail" @location.id}}
          >{{string "location-link"}}</CButton>
          <div class="c-time-series-search-result__catalog-records">
            {{#each (recordsWithResult @location.validCatalogRecords) as | record |}}
              <div class="c-time-series-search-result__catalog-records-label"
              >Catalog Record</div>
              <div class="c-time-series-search-result__catalog-record">
                <span class="c-time-series-search-result__catalog-record-title">
                  <CButton @type="small muted" @external="true"
                    @linkTo={{array "catalog.record" record.id}}
                  >Record Details</CButton>
                  {{#if record.generationEffort}}
                    {{record.generationEffort}}
                  {{else}}
                    {{record.title}}
                  {{/if}}
                </span>
                <div class="c-time-series-search-result__items">
                  {{#each (groupedItemsWithResult record.groupedItems.ordered) as | groupedItems |}}
                    {{#if (itemTypeIdsEq groupedItems.typeId (itemTypeId "TIME_SERIES"))}}
                      <div class="c-time-series-search-result__items-label"
                      >{{titleCase (string "catalog-items")}}</div>
                      {{#each groupedItems.items as | item |}}
                        <div class="c-time-series-search-result__item">
                          <span class="c-time-series-search-result__item-type"
                          >{{item.type}}</span>
                          <span class="c-time-series-search-result__item-title">
                            <CButton @type="small muted" @external="true"
                              @linkTo={{array "catalog.record.item" record.id item.id}}
                            >Item Details</CButton>
                            {{#if item.parameter}}
                              {{titleCase (oneString
                                item.isActuallyModeled "item-modeled-value"
                                true "item-observed-value"
                              )}}
                              {{parameterTimestep item.parameter.parameterTimestep}}
                              {{parameterTransformation item.parameter.parameterTransformation}}
                              {{item.parameter.parameterName}}
                              {{~if item.parameter.parameterUnit
                                (concat " (" (parameterUnit item.parameter.parameterUnit) ")")
                              }}
                            {{else}}
                              {{item.title}}
                            {{/if}}
                          </span>
                          {{#if (and item.isModeled item.modelRuns.length)}}
                            <div class="c-time-series-search-result__model-runs">
                              <div class="c-time-series-search-result__model-runs-label">
                                {{titleCase (if item.hasProfile
                                  "model-run-profile"
                                  "model-runs"
                                )}}
                              </div>
                              {{#each item.modelRuns as | modelRun |}}
                                <div class="c-time-series-search-result__model-run">
                                  {{modelRun.title}}
                                </div>
                              {{/each}}
                            </div>
                          {{/if}}
                        </div>
                      {{/each}}
                    {{/if}}
                  {{/each}}
                </div>
              </div>
            {{/each}}
          </div>
        </:body>
      </ExpandingBlock>
    </div>
  </template>
}
